import React, {useContext, useEffect, useState, useRef} from "react";
import { Link, useNavigate } from "react-router-dom";

import logo from "./../../../Public/img/logo-black.png";
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";
import {globalSearchAPI} from "./../../../API/Team/LeadAPI";

const Header = ({ mobileMenuOpen, setMobileMenuOpen }) =>{

    const navigate = useNavigate();

    const {user, setUser} = useContext(AuthContext);
    const [showprofiledropdown, setShowProfileDropDown] = useState(false);
    const [loggedname, setLoggedName] = useState("");
    const [prifileimage, setProfileImage] = useState("");
    const [txtsearchemail, setTxtSearchEmail] = useState("");
    const profiledropdownRef = useRef(null);
    const profileimagepath = "https://apiv3.edustack360.com/uploads/profile/";

    const dashboardurl = `${window.location.origin}/team/dashboard`;

    useEffect(() =>{
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event)
        {
            if (profiledropdownRef.current && !profiledropdownRef.current.contains(event.target)) 
            {
                setShowProfileDropDown(false);
            }
        }

    }, []);

    useEffect(()=>{

        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);

            setProfileImage(loggeduserdata.image);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }


    }, [])


    const handleShowProfileToggle = ()=>{
        setShowProfileDropDown(!showprofiledropdown);
    }

    const handleLogout = () =>{

        localStorage.removeItem('cpmstoken');
        //sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');
        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    const handleSearchEmail = (e) =>{
        setTxtSearchEmail(e.target.value);
    }

    const handleSearchLead = (e) =>{
        e.preventDefault();

        const formData = new FormData();
        formData.append('searchemail', txtsearchemail);

        globalSearchAPI(formData, navigate);

        setTxtSearchEmail("");
    }

    const handleMobileMenu = (e) => {
        e.preventDefault();

        const isOpen = !mobileMenuOpen;

        setMobileMenuOpen(isOpen);

        if (isOpen) {
            document.documentElement.classList.add("menu-opened");
        } else {
            document.documentElement.classList.remove("menu-opened");
        }
    };

    return (
        <div className="header">
            {/*<div className="header-left active">
                <Link to={dashboardurl} className="logo logo-normal img-logo">
                    <img src={logo} alt="Logo" />

                </Link>
            </div>*/}

            <Link id="mobile_btn" className="mobile_btn" to="#" onClick={handleMobileMenu}>
                <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </Link>

            <div className="header-user">
                <ul className="nav user-menu">
                    <li className="nav-item nav-search-inputs me-auto">
                        <div className="crm-search-box">
                            <input type="text" name="searchemail" id="searchemail" value={txtsearchemail} onChange={handleSearchEmail} placeholder="Search by email..." />

                            <span className="crm-search-icon" onClick={handleSearchLead}>
                                <i className="fas fa-search"></i>
                            </span>
                        </div>     
                    </li>

                                       

                    {/*<li className="nav-item crm-top-icon">🔔</li>*/}

                    <li className="nav-item dropdown has-arrow main-drop">
                        <div className="dropdown profile-dropdown d-flex align-items-center justify-content-center" ref={profiledropdownRef}>
                            <div className={showprofiledropdown ? "topbar-link drop-arrow-none position-relative show" : "topbar-link  drop-arrow-none position-relative"} onClick={handleShowProfileToggle} >
                                
                                {prifileimage !== "" && prifileimage !==  null && prifileimage !== undefined ?
                                <img src={profileimagepath + prifileimage} width="38" className="rounded-circle d-flex" alt="user-image" />
                                :
                                <img src={userlogo} width="38" className="rounded-circle d-flex" alt="user-image" />

                                }

                                <span className="online text-success">
                                    <i className="ti ti-circle-filled d-flex bg-white rounded-circle border border-1 border-white"></i>
                                </span>
                                
                            </div>

                            {showprofiledropdown ?
                            <div className="dropdown-menu dropdown-menu-end dropdown-menu-md p-2 show" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div className="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} className="rounded-circle" width="42" height="42" alt="Img" />
                                    <div className="ms-2">
                                        <p className="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span className="d-block fs-13">Team Leader</span>
                                    </div>
                                </div>

                                <Link to="/team/profile" className="dropdown-item">
                                    <i className="ti ti-user-circle me-1 align-middle"></i>
                                    <span className="align-middle">Profile Settings</span>
                                </Link>          
                                
                                <div className="pt-2 mt-2 border-top">
                                    <button className="dropdown-item text-danger" onClick={handleLogout}>
                                        <i className="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span className="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            :
                            <div className="dropdown-menu dropdown-menu-end dropdown-menu-md p-2" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div className="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} className="rounded-circle" width="42" height="42" alt="Img" />
                                    <div className="ms-2">
                                        <p className="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span className="d-block fs-13">Team Leader</span>
                                    </div>
                                </div>

                                <Link to="/team/profile" className="dropdown-item">
                                    <i className="ti ti-user-circle me-1 align-middle"></i>
                                    <span className="align-middle">Profile Settings</span>
                                </Link>            
                                
                                <div className="pt-2 mt-2 border-top">
                                    <button className="dropdown-item text-danger" onClick={handleLogout}>
                                        <i className="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span className="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </li>                    
                </ul>
            </div>
        </div>
    )

}

export default Header;
